import {createBrowserHistory} from "history";


export const history = createBrowserHistory();

//Paths that share FirstPage's /:code route but are pages, not link codes
export const pages = ['register', 'recheck', 'waiting', 'accepted', 'summary', 'error'];
